<h1>Wybierz format dla swoich zdjęć</h1>
@for (format of availableSizes$ | async; track format) {
  <div
    class="option"
    (click)="picked.next(format.printFormatId)"
    >
    {{ format.label }}
  </div>
}
